// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.getStart-bottom {
  flex-direction: row;
  justify-content: flex-start;
  background: #fff;
  width: 100%;
  padding: 50px 130px 0 130px;
}

.getStart-head {
  font-size: 38px;
  color: #1c2640;
  font-weight: 600;
  margin-left: -120px;
}

.getStart-content {
  margin-top: 3%;
  display: flex;
}

.getStart-btn-footer {
  margin-left: 20%;
}

.getStart-disc {
  width: 58%;
  line-height: 1.86;
  font-size: 18px;
  font-weight: 400;
  margin-left: -120px;
}

button.getStart-schedule-btn {
  background: #ec6927;
  border-radius: 3px;
  padding: 5px 20px;
  margin-right: 20px;
  cursor: pointer;
  color: #fff;
  border: 1px solid #ec6927;
  font-weight: bold;
}

button.getStart-watch-btn {
  background: #1c2640;
  border-radius: 3px;
  padding: 5px 20px;
  margin-right: 20px;
  cursor: pointer;
  color: #fff;
  border: 1px solid #1c2640;
}

img.getStart-dots-bg {
  margin-top: -2%;
  float: right;
  width: 200px;
  margin-right: -280px;
  bottom: -100px;
  height: 90px;
}

.ui.large.modal.transition.visible.active {
  width: 80% !important;
  height: 75vh !important;
  top: 10%;
  left: 10%;
  margin: auto;
}

.ui.modal .image.content {
  padding: 0px !important;
  line-height: 0;
}
.ui.modal .image.content .eaciit-video-player {
  width: 100%;
  height: 75vh;
}`, "",{"version":3,"sources":["webpack://./src/components/GetStart/getstart.scss"],"names":[],"mappings":"AAAI;EACI,mBAAA;EACA,2BAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;AACR;;AAGI;EACI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AAAR;;AAII;EACI,cAAA;EACA,aAAA;AADR;;AAII;EACI,gBAAA;AADR;;AAII;EACI,UAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,iBAAA;AADR;;AAII;EACI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;AADR;;AAII;EACI,eAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,YAAA;AADR;;AAII;EACI,qBAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;AADR;;AAIM;EACE,uBAAA;EACA,cAAA;AADR;AAEQ;EACE,WAAA;EACA,YAAA;AAAV","sourcesContent":["    .getStart-bottom{\n        flex-direction: row;\n        justify-content: flex-start;\n        background: #fff;\n        width: 100%;\n        padding: 50px 130px 0 130px;\n       \n    }\n\n    .getStart-head {\n        font-size: 38px;\n        color: #1c2640;\n        font-weight: 600;\n        margin-left: -120px;\n    }\n\n\n    .getStart-content {\n        margin-top: 3%;\n        display: flex;\n    }\n\n    .getStart-btn-footer {\n        margin-left: 20%;\n    }\n\n    .getStart-disc {\n        width: 58%;\n        line-height: 1.86;\n        font-size: 18px;\n        font-weight: 400;\n        margin-left: -120px;\n    }\n\n    button.getStart-schedule-btn {\n        background: #ec6927;\n        border-radius: 3px;\n        padding: 5px 20px;\n        margin-right: 20px;\n        cursor: pointer;\n        color: #fff;\n        border: 1px solid #ec6927;\n        font-weight: bold;\n    }\n    \n    button.getStart-watch-btn {\n        background: #1c2640;\n        border-radius: 3px;\n        padding: 5px 20px;\n        margin-right: 20px;\n        cursor: pointer;\n        color: #fff;\n        border: 1px solid #1c2640;\n    }\n\n    img.getStart-dots-bg {\n        margin-top: -2%;\n        float: right;\n        width: 200px;\n        margin-right: -280px;\n        bottom: -100px;\n        height: 90px;\n    }\n\n    .ui.large.modal.transition.visible.active{\n        width: 80% !important;\n        height: 75vh !important;\n        top: 10%;\n        left: 10%;\n        margin: auto;\n    }\n    .ui.modal {\n      .image.content{\n        padding: 0px !important;\n        line-height: 0;\n        .eaciit-video-player{\n          width: 100%;\n          height:75vh;\n        }\n      }\n    }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
